// ////////////////////////////////////////////////////////////
// include needed polyfills
import './polyfill';

// ////////////////////////////////////////////////////////////
// polyfill for browsers which don't support xlink:href || href
import svgUseIt from 'svg-use-it';
document.addEventListener('DOMContentLoaded', () => {
    svgUseIt();
});

// ////////////////////////////////////////////////////////////
// check if SVGs are working at all
if (document.createElementNS && document.createElementNS('http://www.w3.org/2000/svg', 'svg').createSVGRect) {
    document.getElementsByTagName('html')[0].setAttribute('class', 'svg');
}

// ////////////////////////////////////////////////////////////
// optimized font loading
import fontFaceLoader from '@spinnwerk/font-face-loader';
fontFaceLoader({
    fonts: ['Titillium Web'],
});

// ////////////////////////////////////////////////////////////
// check if cookies are enabled
let cookieEnabled = (navigator.cookieEnabled) ? true : false;

if (typeof navigator.cookieEnabled == 'undefined' && !cookieEnabled) {
    document.cookie = 'testcookie';
    cookieEnabled = (document.cookie.indexOf('testcookie') != -1) ? true : false;
}

if (!cookieEnabled) {
    document.getElementsByTagName('html')[0].setAttribute('class', 'no-cookies');
}



// WEBPACK FOOTER //
// ./resources/assets/js/critical.js